import {SET_FETCHING} from "./actions";

export default (state = {}, {type, id, isFetching}) => (
    type === SET_FETCHING ? {
        ...state,
        [id]: isFetching,
    } : state
);
